import {
    CREATE_TRANSLATION_FAILURE,
    CREATE_TRANSLATION_SUCCESS,
} from 'store/actions/types';

// Categories
export const createTranslateUtilityFailure = (error) => {
    return {
        type: CREATE_TRANSLATION_FAILURE,
        error: error,
    };
};

export const createTranslateUtilitySuccess = (payload) => {
    return {
        type: CREATE_TRANSLATION_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/utilities/translateActions.js